import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, Checkbox, TableBody, styled, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import "./index.css"
import { DefaultArrayEmpty } from "utilities/utilities";
import ChangeOrder from "components/System/ChangeOrder";
import ChangeOrderCustom from "components/System/ChangeOrderCustom";
import { BtnEditOnTable } from "components/Button/ButtonTable";
import { BtnDelete, BtnEdit, BtnEditData } from "components/Button/ButtonAll";
import HTMLReactParser from "html-react-parser";
import CustomTablePagination from "view/Backend/IncomeExpenses/Ticket/components/CustomTablePagination";

export default function TableStandard(props) {

    const { isPermission, sColumnName, data, handleChangeOrder, arrOptionOrder, onDelete, onEdit, nEditID, arrCheckParent = [], arrCheckParentSec = [], sFieldCheck = "" } = props;
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [dataTable, setdataTable] = useState([]);
    const [selected, setSelected] = useState<readonly number[]>([]);

    useEffect(() => {
        setdataTable(data)
    }, [data])

    const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event?.target?.checked) {
            const newSelected = dataTable.map((n) => n.nID);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(even)': {
            backgroundColor: theme.palette.action.hover,
        }
    }));


    return (
        <>
            <TableContainer id='table-standard' component={Paper}>
                <Table sx={{ minWidth: 500 }}>
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" style={{ minWidth: '100px', width: '10%' }}></TableCell>
                            <TableCell align="center" style={{ minWidth: '100px', width: '10%' }}>ที่</TableCell>
                            <TableCell align="center" style={{ minWidth: '120px', width: '80%' }}>{sColumnName}</TableCell>
                        </TableRow>
                    </TableHead>
                    {
                        dataTable.length > 0 ?
                            <TableBody>
                                {(dataTable.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)).map((row, index) => {
                                    let nNo = (page * rowsPerPage) + (index + 1);
                                    return (
                                        <>
                                            {row.IsHead ?
                                                <>
                                                    <StyledTableRow key={nNo}>
                                                        <TableCell colSpan={4} style={{ background: "#EADDCA" }}>
                                                            {HTMLReactParser(row.sTopic)}
                                                        </TableCell>
                                                    </StyledTableRow>

                                                    {row.lstChildren &&
                                                        DefaultArrayEmpty(row.lstChildren).map((cRow, cIndex) => {
                                                            let nNo = (page * rowsPerPage) + (cIndex + 1);
                                                            return (
                                                                <StyledTableRow key={"child_" + nNo}>

                                                                    <TableCell align="center" >
                                                                        {isPermission &&
                                                                            <Grid container spacing={1}>
                                                                                <Grid item xs={6}>
                                                                                    <BtnDelete
                                                                                        id="EditDelete"
                                                                                        IsCircleWithOutText
                                                                                        onClick={() => onDelete(cRow.nID)}
                                                                                        IsDisabled={arrCheckParent.filter(f => f[sFieldCheck] === cRow.nID).length > 0 || arrCheckParentSec.filter(f => f[sFieldCheck] === cRow.nID).length > 0}
                                                                                    />
                                                                                </Grid>
                                                                                <Grid item xs={6}>
                                                                                    <BtnEditData
                                                                                        id="EditGoal"
                                                                                        IsCircleWithOutText
                                                                                        bgcolor="#F6C000"
                                                                                        bgcolorHover="#F6C000"
                                                                                        onClick={() => onEdit(cRow.nID)}
                                                                                        IsDisabled={cRow.nID === nEditID}
                                                                                    />
                                                                                </Grid>
                                                                            </Grid>
                                                                        }
                                                                    </TableCell>

                                                                    <TableCell align="center" >
                                                                        {isPermission ?
                                                                            <ChangeOrderCustom
                                                                                item={cRow}
                                                                                value={cRow.nOrder}
                                                                                onChangeOrder={(sID, nOrder) =>
                                                                                    handleChangeOrder(row.nID, +nOrder, +cRow.nOrder)
                                                                                }
                                                                                optOrder={arrOptionOrder.filter(f => f.nID === row.nID)}
                                                                                IsView={false}
                                                                            /> :
                                                                            <>{cRow.nOrder}</>
                                                                        }

                                                                    </TableCell>
                                                                    <TableCell align="left" >
                                                                        {cRow.sName}
                                                                    </TableCell>
                                                                </StyledTableRow>
                                                            )
                                                        })
                                                    }
                                                </>
                                                :
                                                <StyledTableRow key={nNo}>
                                                    <TableCell align="center" >
                                                        {isPermission &&
                                                            <Grid container spacing={1}>
                                                                <Grid item xs={6}>
                                                                    <BtnDelete
                                                                        id="EditDelete"
                                                                        IsCircleWithOutText
                                                                        onClick={() => onDelete(row.nID)}
                                                                        IsDisabled={arrCheckParent.filter(f => f[sFieldCheck] === row.nID).length > 0 || arrCheckParentSec.filter(f => f[sFieldCheck] === row.nID).length > 0}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <BtnEditData
                                                                        id="EditGoal"
                                                                        IsCircleWithOutText
                                                                        bgcolor="#F6C000"
                                                                        bgcolorHover="#F6C000"
                                                                        onClick={() => onEdit(row.nID)}
                                                                        IsDisabled={row.nID === nEditID}
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                        }
                                                    </TableCell>

                                                    <TableCell align="center" >
                                                        {isPermission ?
                                                            <ChangeOrderCustom
                                                                item={row}
                                                                value={row.nOrder}
                                                                onChangeOrder={(sID, nOrder) =>
                                                                    handleChangeOrder(+nOrder, +row.nOrder)
                                                                }
                                                                optOrder={arrOptionOrder}
                                                                IsView={false}
                                                            />
                                                            :
                                                            <>{row.nOrder}</>
                                                        }

                                                    </TableCell>
                                                    <TableCell align="left" >
                                                        {row.sName}
                                                    </TableCell>
                                                </StyledTableRow>
                                            }
                                        </>
                                    )
                                })}
                            </TableBody>
                            :
                            <TableRow key={"r-no-data"} >
                                <TableCell align="center" colSpan={3}>ไม่พบข้อมูล</TableCell>
                            </TableRow>
                    }
                </Table>
            </TableContainer>
            <CustomTablePagination
                dataTable={dataTable}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                page={page}
                setPage={setPage}
                colSpan={3}
                selection={selected}
                onDelete={onDelete}
                handleSelectAllClick={handleSelectAllClick}
            />
        </>
    )
}